"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_CRYPTO_SELL = exports.DEFAULT_CRYPTO_BUY = exports.DEFAULT_FIAT_AMOUNT = exports.DEFAULT_CRYPTO_CODE = exports.DEFAULT_FIAT_CODE = exports.PRIORITY_CRYPTO_SELL = exports.PRIORITY_CRYPTO = exports.PRIORITY_FIAT = exports.FALLBACK_COUNTRY = exports.DEFAULT_LOCALE = void 0;
const cryptoOptions_1 = __importDefault(require("./cryptoOptions"));
exports.DEFAULT_LOCALE = "en";
// Country to fallback to if country isn't in countriesList.ts
exports.FALLBACK_COUNTRY = "US";
// Fits which show at top of list (in this order)
exports.PRIORITY_FIAT = ["USD", "EUR", "GBP", "CAD", "AUD"];
// Popular Cryptos (shows at top in order)
exports.PRIORITY_CRYPTO = ["BTC", "VERSE", "ETH", "BCH"];
exports.PRIORITY_CRYPTO_SELL = ["BTC", "ETH", "BCH"];
// default usd
exports.DEFAULT_FIAT_CODE = "USD";
// default btc
exports.DEFAULT_CRYPTO_CODE = "BTC";
// Default USD value which autopopulates other currencies
exports.DEFAULT_FIAT_AMOUNT = 200;
// default crypto on buy/sell list
exports.DEFAULT_CRYPTO_BUY = Object.assign({ code: "BTC" }, cryptoOptions_1.default.BTC);
exports.DEFAULT_CRYPTO_SELL = Object.assign({ code: "BTC" }, cryptoOptions_1.default.BTC);
//# sourceMappingURL=constants.js.map